export enum VipTaskMarksEnum {
  POPULAR = 'POPULAR',
  NEW = 'NEW',
  USER_CHOICE = 'USER_CHOICE',
}

export enum VipTaskItemUserIdentifierTypesEnum {
  USER_ID = 'USER_ID',
  EMAIL = 'EMAIL',
  USER_NAME = 'USER_NAME',
  ROYALS_ID = 'ROYALS_ID',
}

export enum VipTaskTypesEnum {
  PLATFORM = 'PLATFORM',
  PARTNER = 'PARTNER',
}

export enum VipTaskItemTypesEnum {
  COMPLETE_TASKS = 'COMPLETE_TASKS',
  JOIN_TOURNAMENTS = 'JOIN_TOURNAMENTS',
  VALIDATE_PARTNER_ACTION = 'VALIDATE_PARTNER_ACTION',
}

export const VIP_TASK_ITEM_PLATFORM_ACTION_TYPES = [
  VipTaskItemTypesEnum.COMPLETE_TASKS,
  VipTaskItemTypesEnum.JOIN_TOURNAMENTS,
];

export const VIP_TASK_ITEM_PARTNER_ACTION_TYPES = [VipTaskItemTypesEnum.VALIDATE_PARTNER_ACTION];

export enum VipTaskItemStatusesEnum {
  INACTIVE,
  PENDING,
  DONE,
}
